import TimestampCell from '../VaultCollection/Cells/TimestampCell'
import { DownloadOrionDocumentCell } from './cells/DownloadOrionDocumentCell'
import VisibilityCell from './cells/VisibilityCell'

const defaultColumnConfig = [
  {
    id: 'name',
    accessor: 'blobText',
    Header: 'Name'
  },
  {
    id: 'description',
    accessor: 'blobDesc',
    Header: 'Description'
  },
  {
    id: 'category',
    accessor: 'category',
    Header: 'Category'
  },
  {
    id: 'createdDate',
    accessor: 'createdDate',
    Header: 'Created Date',
    cell: 'timestamp'
  },
  {
    id: 'download',
    accessor: 'id',
    Header: 'Download',
    cell: 'download',
    width: 100,
    data: {
      contentDisposition: 'attachment'
    }
  }
]

const CustomCellsMap = {
  timestamp: TimestampCell,
  download: DownloadOrionDocumentCell,
  visibility: VisibilityCell
}

export const getColumnConfig = (columns) => {
  return (!columns?.length ? defaultColumnConfig : columns).map(col => {
    const customCell = CustomCellsMap[col.cell]

    return {
      ...col,
      key: col?.key ?? col?.id ?? col?.accessor,
      Header: col?.Header ?? col?.header ?? col?.label ?? col?.accessor,
      ...(customCell ? { Cell: customCell } : {})
    }
  })
}
